import { render, staticRenderFns } from "./ProsCons.vue?vue&type=template&id=fac777da&scoped=true"
import script from "./ProsCons.vue?vue&type=script&lang=ts"
export * from "./ProsCons.vue?vue&type=script&lang=ts"
import style0 from "./ProsCons.vue?vue&type=style&index=0&id=fac777da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac777da",
  null
  
)

export default component.exports